import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnumToArrayModule } from 'src/app/shared/modules/enumToArrayPipe/enum-to-array/enum-to-array.module';
import { UpdateOrganizationComponent } from './update-organization.component';

import { UpdateOrganizationRoutingModule } from './update-organization-routing.module';


@NgModule({
  declarations: [UpdateOrganizationComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    EnumToArrayModule,
    ReactiveFormsModule
  ],
  exports: [UpdateOrganizationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpdateOrganizationModule { }
